<template>
  <div class="container flex mt15">
    <div id="test" class="flex ml10">
      <div class="leftNav  flex1" v-if="!isShow">
        <div style="width: 97%">
          <el-input placeholder="请 查询" clearable v-model="company" @blur="searchcomp" prefix-icon="el-icon-search"></el-input>
        </div>
        <div style="height: 95%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-submenu :index="String(index)" v-for="(item, index) in companyList1.length ? companyList1 : companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index)}-${String(ind)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>

      <!-- 这里有一个flex1 -->
      <div class="content flex1" style="position: relative;">
        <div
          class="canvas"
          ref="crtDimension"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'absolute',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousemove="moveMouse"
          v-if="dwImg"
        >
          <crtmarker ref="aiPanel" @added="added" :imgUrl="dwImg" :idx="0" :iconId="iconId" @isOpenDirectionDia="isOpenDirectionDia" />
        </div>
      </div>
      <div class="rightnav " style="width: 25%; height: 91%" v-if="!isShow">
        <div style="width: 100%" class="center">
          <el-col :span="24">
            <el-input placeholder="请输入部位号或名称查询" clearable v-model="rightParams.true_addr" prefix-icon="el-icon-search" @clear="pointList"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" class="ml10" style="margin-top: 0px" size="small" @click="searchRight">查询</el-button>
          </el-col>
          <el-col :span="5">
            <el-button class="ml10" style="margin-top: 0px" size="small" @click="reset">重置</el-button>
          </el-col>
        </div>
        <div style="width:100%; height:90%;overflow:auto;">
          <el-table :data="qvyuList" class="" style="">
            <el-table-column prop="number" label="部位号" align="center"> </el-table-column>
            <el-table-column prop="true_addr" label="部位名称" align="center"> </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" :type="scope.row.isMark ? 'warning' : 'primary'" icon="el-icon-edit" @click="markp(scope.row, scope.$index)"></el-button>

                <el-popconfirm title="确定删除此点位吗？" class="cursor" @confirm="cancle(scope.row)" @onConfirm="cancle(scope.row)">
                  <a slot="reference" class="red">
                    <el-button type="danger" icon="el-icon-delete" size="mini"></el-button>
                  </a>
                </el-popconfirm>
                <el-button size="mini" type="info" icon="el-icon-video-camera" plain @click="markp(scope.row, scope.$index, true)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="rightParams.pageNum"
          @size-change="pageChange"
          @current-change="pageChange"
          :page-size.sync="rightParams.rightNum"
          :total="rightNum"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="videoAddr + '点位摄像头'" width="80%" :visible.sync="comara">
      <div style="min-height: 300px">
        <div v-if="videoList.length" style="height: 100%; overflow: auto; flex-wrap: wrap" class="flex">
          <div v-for="(item, index) in videoList" :key="index" class=" ml20" style="height:100%">
            <!-- <div  v-html="item" >
            </div> -->
            <div style="height:100%;">
              <div class="selectVideo" @click="clickPlayer(index)">
                <cus-player :ref="'video' + index" :id="'video' + index" v-if="item.name !== '海康萤石云'"></cus-player>
                <iframe height="100%" allowfullscreen width="100%" :src="'https://open.ys7.com/ezopen/h5/iframe?url=' + item.content" v-else frameborder="0"></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="center" v-else>
          <span>暂无数据</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
import crtmarker from '../../components/crtmarker';
import CusPlayer from '../../components/CusPlayer.vue';

import { getMapByid } from '../../api/common';
import 'xgplayer';
import FlvJsPlayer from 'xgplayer-flv.js';
import config from '../../utils/config.js';

export default {
  props: ['isShow', 'it'],
  components: {
    CusPlayer,
    crtmarker,
  },
  data() {
    return {
      num: 1,
      isdraged: false,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表

      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      comara: false, //点位摄像头
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: '',
      videoIndex: 0,
      playUrl: '',
      rightParams: {
        area_uuid: '',
        number: '',
        true_addr: '',
        page: 1,
        pageNum: 1,
      },
      rightNum: 10,
      videoAddr: '',
      form: {}, //最终确定的点位
      dwImg: '',
      radio1: '',
      iconId: '',
    };
  },
  watch: {
    // isdraged(val){
    //   if(!val){
    //     // this.$message.warning('选择点位标注')
    //       this.setQuery('block')
    //   }else{
    //         this.getdwList()
    //     // this.$message.warning('退出点位标注')
    //       // this.setQuery('none')
    //   }
    // }
    it(val) {
      if (val) this.checkCop(val);
    },
    comara(val) {
      if (!val) {
        this.videoList = [];
      }
    },
    iconId() {
      this.getdwList();
    },
  },
  created() {
    getMapByid(176).then((res) => {
      this.typeList = res.data;
    });
    // 获取单位
    this.$post('/crt/crtmenu', { type: 1 }).then((res) => {
      this.companyList = res.data;
      // console.log(res, 'get data');
      if (this.it) this.checkCop(this.it);
    });
  },
  methods: {
    pageChange(val) {
      // console.log(val)
      this.rightParams.page = val;
      this.getdwList();
    },
    reset() {
      this.rightParams.number = '';
      this.rightParams.true_addr = '';
      this.getdwList();
    },
    searchRight() {
      this.rightParams.number = this.rightParams.true_addr;
      this.getdwList();
    },
    handlePlay() {
      if (this.videoList[this.videoIndex].isPlay == false) {
        if (this.playUrl) {
          let ref = 'video' + this.videoIndex;
          setTimeout(() => {
            this.$refs[ref][0].createPlayer(this.playUrl, false, this.videoIndex);
            this.videoList[this.videoIndex].isPlay = true;
          }, 10);

          // this.$refs[ref].createPlayer(this.playUrl, true, this.videoIndex);
        } else {
          this.$message.error('请填写播放地址');
        }
      }
    },
    playVideo() {},
    // clickPlayer(index) {
    //   this.videoIndex = index ? index : 0;
    //   var url = `${config.camraWs}?url=${this.videoList[index].content}`;
    //   this.playUrl = url
    //   this.handlePlay()
    // },

    clickPlayer(index) {
      this.videoIndex = index ? index : 0;
      var url = this.videoList[index].content;
      if (url.indexOf('ezopen') > -1) {
        url = url;
      } else {
        url = `${this.videoList[index].webUrl ? this.videoList[index].webUrl + '/live' : config.camraWs}?url=${this.videoList[index].content}`;
        //  'ws://192.168.0.251:8866/live?url=192.168.1.1'
      }
      this.playUrl = url;
      this.handlePlay();
    },

    viewcamra(it) {
      this.videoAddr = it.true_addr;
      this.videoList = [];

      this.comara = true;
      this.getVideoList(it);
    },
    // 获取监控列表
    getVideoList(it) {
      this.videoList = [];
      this.$post('/crt/crtkind', { point_uuid: it.point_uuid }).then((res) => {
        // console.log(res, 'get video list');
        var videoList = [];
        if (res.data.length) {
          res.data.map((item) => {
            // 1 标清 2高清
            this.$post('/crt/videoaddress', { video_ip: item.number, type: 1, companyNum: item.companyNum }).then((RES) => {
              //  RES.code==200  ?    videoList.push({content:RES.data,isPlay:false}) : this.$message.warning(`${item.number}设备不存在！`)
              if (RES.code == 200) {
                console.log(RES);
                if (RES.isonly == 1) {
                  // this.getYSY(arr[0].ip);
                  this.$get('basevideo/videotoken').then((Res) => {
                    if (Res.code == 200) {
                      var url = `ezopen://open.ys7.com/${item.number}/1.live&accessToken=${Res.data}`;
                      videoList.push({
                        content: url,
                        // address: arr[0].address,
                        // ip:item.ip,
                        // trueName: it.trueName,
                        // number: it.tag,
                        isPlay: false,
                        name: item.name,
                        webUrl: item.url || '',
                      });
                    }
                  });
                } else {
                  videoList.push({
                    content: RES.data,
                    // address: arr[0].address,
                    // ip:item.ip,
                    // trueName: it.trueName,
                    // number: it.tag,
                    isPlay: false,
                    name: item.name,
                    webUrl: item.url || '',
                  });
                }
                this.videoList = videoList;
                console.log(this.videoList);
                return;
              } else {
                this.$message.warning(`${arr[0].ip}设备不存在！`);
              }
            });
          });
        }
      });
      // this.videoList.push({
      //   content:
      //     "rtmp://rtmp01open.ys7.com:1935/v3/openlive/230613582_1_1?expire=1663208890&id=360009237713317888&t=bb5238dd9eb0b0b3849b1d09cb45e992e1268ae59b5dfb25a7f5b8e5bb2deebb&ev=100",
      //   isPlay: false,

      // });
    },
    // 获取萤石云的摄像头
    // getYS(arr){
    //   console.log(this.videoList)
    //    this.$get('basevideo/videotoken').then(Res=>{
    //      arr.map(item=>{
    //        // 如果是海康萤石云 获取网址 赋值iframe
    //         if(item.name==='海康萤石云'){
    //              item.vUrl = `ezopen://open.ys7.com/${item.number}/1.live&accessToken=${Res.data}`
    //               item.turn = 0
    //         }
    //         this.videoList.push(item)
    //       })
    //    })

    // },
    // 看坐标
    setQuery() {
      var name = this.isdraged ? 'none' : 'block';
      const markers = document.querySelectorAll('.g-image-op');
      for (var i = 0; i < markers.length; i++) {
        markers[i].style.display = name;
      }
    },
    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
    },

    //取消标点
    cancle(it) {
      if (this.selectPoint.point_uuid) {
        this.$message.error('请先标记已选择点位！');
        return;
      }
      var obj = {
        point_uuid: it.point_uuid,
        x_axis: '',
        xa_axis: '',
        y_axis: '',
        ya_axis: '',
      };
      this.$post('crt/crtupdatedot', obj).then((res) => {
        // this.$message.success('删除成功');
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.isdraged = true;
        this.getdwList();
      });
    },
    // 标点
    markp(it, ind, camra) {
      var data = null;
      this.$refs['aiPanel'].remove();
      this.$refs['aiPanel'].getBiaozhu(this.pointList);
      this.isdraged = false;

      if (!camra) {
        this.pointList.map((item) => {
          if (item.point_uuid === it.point_uuid) {
            if (this.selectPoint.point_uuid) {
              this.$message.warning('请先标记已选择点位！');
              return;
            }
            this.selectPoint = item;
            this.$refs['aiPanel'].startBiaoZhu(this.selectPoint);
          }
        });

        this.setQuery();
      }
      if (camra) {
        this.viewcamra(it, ind);
      }
    },

    // setPoint(point) {
    //   this.$refs["aiPanel-editor"].getMarker().renderData(point);
    // },
    // clearPoint(){
    //   this.$refs["aiPanel-editor"].getMarker().clearData();
    // },
    //获取点位
    getdwList() {
      this.$post('/crt/crtright', this.rightParams).then((res) => {
        var companylist = [];
        var pointList = [];
        this.rightNum = res.data.count;
        res.data.list.map((item) => {
          this.iconId = item.id;
          var obj1 = {
            number: item.number,
            true_addr: item.true_addr,
            point_uuid: item.point_uuid,
            isMark: item.x_axis ? true : false,
            arrow_remark: item.arrow_remark,
          };
          var obj2 = {
            tag: item.number,
            tagName: `<div>
                       部位编号：${item.number}<br/>
                       部位名称：${item.true_addr}
                      </div>`,

            x: item.x_axis,
            y: item.y_axis,
            type: item.point_type,
            point_uuid: item.point_uuid,
            arrow_remark: item.arrow_remark,
          };
          companylist.push(obj1);
          pointList.push(obj2);
        });
        this.qvyuList = companylist;
        this.pointList = pointList;
        this.$refs['aiPanel']?.remove();
        this.$refs['aiPanel']?.getBiaozhu(this.pointList);
      });
    },

    // 选择区域的点
    checkCop(it) {
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.pageNum = 1;
      this.dwImg = it.image_name;
      this.getdwList();
      this.rightParams.page = 1;
    },
    //准备完成时
    ready() {
      // console.log(this.pointList)
    },
    //更新时
    update(v) {
      if (!this.add && this.selectPoint.point_uuid) {
        // 新增的变化
        this.form = {};
        this.form = { ...this.selectPoint, ...v[0] };
      } else {
      }
    },

    added(v) {
      this.selectPoint = {};
      this.$post('/crt/crtupdatedot', v).then((res) => {
        // this.$message.success('保存成功');
        this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
        this.getdwList();
        // this.draged
        this.isdraged = !this.isdraged;
      });
    },
    //选中标点时
    selected(v) {
      this.isdraged = false;
      this.selectPoint = v;
      this.form = this.selectPoint;
    },
    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },
    isOpenDirectionDia(status) {
      // this.getdwList();
    },
    //列表关闭是
    handleClose() {},
    // 列表展开是
    handleOpen() {},
    // 拖拽 目前还未使用
    moveMouse(e) {
      if (!this.isdraged) {
        // 获取dom
        var ooid = this.$refs.crtDimension; //获取目标元素
        ooid.onmousedown = function(event) {
          var dx = event.clientX - ooid.offsetLeft;
          var dy = event.clientY - ooid.offsetTop;
          // 鼠标拖拽的时候
          ooid.onmousemove = function(event) {
            // console.log(event, 'move cursor to position');
            //绑定元素位置到positionX和positionY上面
            event = event || window.event;

            var left = event.clientX;
            var top = event.clientY;
            //移动当前元素
            ooid.style.left = left - dx + 'px';
            ooid.style.top = top - dy + 'px';
          };
          // 清除 防止双击后图片跟着鼠标走
          ooid.onmouseup = function() {
            ooid.onmousemove = null;
            ooid.onmousedown = null;
          };
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
.BiaoZhu {
  position: relative;
  // height: 100%;
  width: 100%;
}
.canvas {
  display: flex;
  align-items: center;
}
.container {
  width: 100%;
  height: 90%;
  justify-content: space-around;
  .topnav {
    height: 20%;
  }
  .leftNav {
    // height: 100%;
    max-width: 23%;
  }
  #test {
    width: 100%;
    // height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 70%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      // margin: 0 auto;
      overflow: hidden;
      border: 1px solid gray;
    }
  }
}
.mt15 {
  margin-top: 0.9375rem;
}
</style>
